const getRuntimeApiUrl = () => {
  if (typeof window === 'undefined') return 'http://localhost:5000';
  const { protocol, hostname } = window.location;
  if (
    hostname === 'esanza.com'
    || hostname === 'www.esanza.com'
    || hostname === 'admin.esanza.com'
  ) {
    return `${protocol}//api.esanza.com`;
  }
  return 'http://localhost:5000';
};

export const API_URL = process.env.REACT_APP_API_URL || getRuntimeApiUrl();

export async function apiGet<T>(path: string): Promise<T> {
  const response = await fetch(`${API_URL}${path}`);
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
  return response.json();
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.message || data?.error || `Request failed: ${response.status}`);
  }
  return data;
}
